<template>
    <div class="flex items-center space-x-4">
        <div class="min-w-[140px] !text-[0.85rem] text-gray-700 font-semibold  whitespace-nowrap flex-shrink-0">
            PROGRESO {{ progress }}%
        </div>
        <div class="w-full h-4 bg-gray-200 rounded-lg overflow-hidden">
            <div class="h-full transition-all duration-500" :class="barColor" :style="{ width: `${progress}%` }"></div>
        </div>
    </div>
</template>

<script setup>
import { computed, defineProps } from "vue";
import dayjs from "dayjs";

const props = defineProps({
    startDate: {
        type: String,
        required: true, // Formato: "YYYY-MM-DD"
    },
    totalMeetings: {
        type: Number,
        required: true,
    },
    color: {
        type: String,
        default: "bg-blue-500",
    },
});

const progress = computed(() => {
    const start = dayjs(props.startDate);
    const today = dayjs();

    // Calcular horas transcurridas desde el inicio
    const hoursPassed = today.diff(start, "hour");
    
    // Asumimos que cada reunión dura 1 hora
    const totalHours = props.totalMeetings;
    
    let percentage = Math.min((hoursPassed / totalHours) * 100, 100);
    if (percentage < 0) {
        percentage = 0;
    }
    return Math.round(percentage);
});

const barColor = computed(() => props.color);
</script>
